import React from 'react';
import { Paper, Text, Button, Group, ThemeIcon, Stack } from '@mantine/core';
import { IconBolt, IconBriefcase } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

const QuickStartBanner: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Paper withBorder p="lg" radius="md" bg="var(--mantine-color-blue-light)">
            <Group justify="space-between" align="center">
                <Group align="flex-start">
                    <ThemeIcon size={40} radius="md" variant="filled" color="blue">
                        <IconBolt size={24} />
                    </ThemeIcon>
                    <Stack gap={4}>
                        <Text fw={700} size="lg">
                            Quick Start Resume
                        </Text>
                        <Text size="sm" c="dimmed" style={{ maxWidth: 500 }}>
                            Paste a job description to instantly generate a tailored resume based on your master resume.
                        </Text>
                    </Stack>
                </Group>

                <Group>
                    {/* Placeholder action - redirect to add job modal? Or just jobs page? */}
                    <Button
                        leftSection={<IconBriefcase size={16} />}
                        variant="filled"
                        color="blue"
                        onClick={() => { /* TODO: Open add job modal */ }}
                    >
                        Paste Job Description
                    </Button>
                </Group>
            </Group>
        </Paper>
    );
};

export default QuickStartBanner;
